export interface WizardStepDefinition {
  key: string
  title: string
  description: string
}

/* The five steps of the add wizard, in the order the onboarding API declares
 * them. The titles and copy are design-owned — the manifest's own step copy
 * differs (its connector_domain title is "Connection type"). */
export const WIZARD_STEPS: WizardStepDefinition[] = [
  {
    key: 'init',
    title: 'Connection Details',
    description: 'Provide the necessary information to establish and configure your connection.'
  },
  {
    key: 'connector_domain',
    title: 'Connector Domain',
    description:
      "Choose which domain this Jira integration will support. Once the integration is saved, this domain can't be changed."
  },
  {
    key: 'connected_projects',
    title: 'Project Selection',
    description: 'Select the Jira project you want to connect.'
  },
  {
    key: 'data_filters',
    title: 'Data Filtering',
    description: 'Specify the criteria to filter and refine the data for accurate results.'
  },
  {
    key: 'data_mapping',
    title: 'Data Mapping',
    description: 'Match the Jira data fields to their corresponding Onyxia target fields for proper alignment.'
  }
]

export const stepIndexOf = (key?: string | null) => {
  const index = WIZARD_STEPS.findIndex((step) => step.key === key)

  return index === -1 ? 0 : index
}

export const INSTRUCTIONS_TITLE = 'Instructions'

export const INSTRUCTIONS_DESCRIPTION = 'Follow these steps to successfully set up and configure your connection'

/* The right pane on the steps that precede any previewable data. */
export const PREVIEW_EMPTY_STATES: Record<string, { title: string; description: string }> = {
  connector_domain: {
    title: 'No Preview Available',
    description: 'Complete the setup steps to preview data sample'
  },
  connected_projects: {
    title: 'Preview Will Appear Here',
    description: 'Complete the setup steps to preview data sample'
  }
}
